'use client'

// React Imports
import type { CSSProperties } from 'react'
import { useEffect, useRef, useTransition } from 'react'

// Third-party Imports
import { usePathname, useRouter } from 'next/navigation'

// Type Imports

// Hook Imports
import ProgressBar from '@/components/ProgressBar'
import { useSettings } from '@core/hooks/useSettings'
import useVerticalNav from '@menu/hooks/useVerticalNav'

const Logo = ({ color }: { color?: CSSProperties['color'] }) => {
  // Refs
  const logoTextRef = useRef<HTMLSpanElement>(null)

  // Hooks
  const { isHovered } = useVerticalNav()
  const { settings } = useSettings()

  // Vars
  const { layout } = settings

  useEffect(() => {
    if (layout !== 'collapsed') {
      if (logoTextRef && logoTextRef.current) {
        logoTextRef.current.classList.remove('hidden')
      }

      return
    }

    if (logoTextRef && logoTextRef.current) {
      if (layout === 'collapsed' && !isHovered) {
        logoTextRef.current?.classList.add('hidden')
      } else {
        logoTextRef.current.classList.remove('hidden')
      }
    }
  }, [isHovered, layout])
  useEffect(() => {
    if (layout == 'collapsed') {
      if (logoTextRef && logoTextRef.current) {
        logoTextRef.current?.classList.add('hidden')
      }
    }
  }, [logoTextRef.current, layout])
  const pathname = usePathname()
  const router = useRouter()
  const [isPending, startTransition] = useTransition()

  const handleLinkClick = () => {
    if (pathname === '/') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    } else {
      startTransition(() => {
        router.push('/')
      })
    }
  }

  return (
    <>
      {isPending && <ProgressBar />}
      <div
        className='flex items-center min-bs-[24px] cursor-pointer transition duration-150 ease-in-out hover:scale-110'
        onClick={handleLinkClick}
      >
        <img src='/images/icon/logo_white.png' alt='logo' width={150} height={80} />
      </div>
    </>
  )
}

export default Logo
